import { cleanNum } from '@oliasoft-open-source/units';

export const normalizeNumberInputValue = (value: string): string | number => {
  if (value.endsWith(',') || value.endsWith('.')) {
    return value;
  }
  return cleanNum(value.replace(/,/, '.')) || 0;
};

export const normalizeDecimalInputValue = (value: string): string | number => {
  const normalizedValue = value.replace(/,/, '.');
  if (normalizedValue.endsWith('.') || (normalizedValue.includes('.') && normalizedValue.endsWith('0'))) {
    return normalizedValue;
  }
  return parseFloat(normalizedValue) || 0;
};
